// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronTop: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M0 14C0 6.3 6.3 0 14 0s14 6.3 14 14-6.3 14-14 14S0 21.7 0 14zm26.5 0c0-6.9-5.6-12.5-12.5-12.5S1.5 7.1 1.5 14 7.1 26.5 14 26.5 26.5 20.9 26.5 14z" />
            <path
                fill="#292929"
                fillRule="evenodd"
                d="M8.6 17.4l5.3-5.5 5.4 5.5 1.6-1.7-7-7.1-7 7.1z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(ChevronTop);
